import type { DriveEnv } from './environment.default';
import { ENVIRONMENT, environment as defaultEnv } from './environment.default';

export const environment: DriveEnv = {
  ...defaultEnv,
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: 'a8a46871-5761-48a3-8bcc-65d83f968b69',
  PROTECTED_URIS: {
    DRIVE: 'https://storage.api.ca.connect.dev-evcnt.com/v1',
  },
  AI_FLOWS_POC_ORG_IDS: [
    '47b391ae-f9a5-4ad0-a163-e9344ff6ac2b' // Evident Industrial
  ]
};
